/**
 * Cheap shape check for the `ad_brief_asset_versions.svg` column. The column
 * stores SVG (legacy / motion ads) or HTML (static ads written by the new
 * pipeline); callers branch on the format to pick the right rasterizer or
 * editor. The regex matches the leading element name without parsing the
 * full payload.
 */
export function looksLikeHtml(content: string): boolean {
  return /^\s*<(div|html|!doctype)/i.test(content);
}
